<template>
  <button class="FormButtonCheckbox btn d-flex align-items-center" :class="active ? 'btn-success' : 'btn-danger'" type="button">
    <div class="content d-flex align-items-center">
      <slot></slot>
    </div>

    <FormCheckbox v-if="!removeCheckbox" :value="active"
      :white="true"
    
      class="form-checkbox"
      :updateOnClick="false"
    />
  </button>
</template>

<script>

import FormCheckbox from "./FormCheckbox.vue"

export default {
  components: {
    FormCheckbox,
  },
  props: {
    removeCheckbox: {
      type: Boolean,
      default: true,
    },
    active: {
      type: [Boolean, String],
      required: false,
    },
  },
}

</script>

<style scoped>

.form-checkbox {
  width: 20px;
  flex: 1;
  font-weight: 700;
  padding: 0 !important;
  margin-top: 4px;
}

.btn {
  padding: 0px; 
  display: flex !important;
}

.content {
  padding: 0 !important;
  transform: translateY(1px);
}

</style>

<style>

.FormButtonCheckbox .checkbox-wrapper {
  display: block;
  padding: 0px;
  transform: translate(-7px, -3px) !important;
}

.FormButtonCheckbox .form-check-sign::before,
.FormButtonCheckbox .form-check-sign::after {
  color: white;
}

</style>
